import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78e3fae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidenav-content" }
const _hoisted_2 = {
  key: 0,
  class: "sidenav-category"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidenav-category-title" }, "고객관리", -1 /* HOISTED */))
const _hoisted_4 = { class: "sidenav-category-items" }
const _hoisted_5 = {
  key: 1,
  class: "sidenav-category"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidenav-category-title" }, "구독관리", -1 /* HOISTED */))
const _hoisted_7 = { class: "sidenav-category-items" }
const _hoisted_8 = {
  key: 2,
  class: "sidenav-category"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidenav-category-title" }, "콜봇", -1 /* HOISTED */))
const _hoisted_10 = { class: "sidenav-category-items" }
const _hoisted_11 = {
  key: 3,
  class: "sidenav-category"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidenav-category-title" }, "연동관리", -1 /* HOISTED */))
const _hoisted_13 = { class: "sidenav-category-items" }
const _hoisted_14 = {
  key: 4,
  class: "sidenav-category"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidenav-category-title" }, "계정관리", -1 /* HOISTED */))
const _hoisted_16 = { class: "sidenav-category-items" }
const _hoisted_17 = {
  key: 5,
  class: "sidenav-category"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidenav-category-title" }, "보안설정", -1 /* HOISTED */))
const _hoisted_19 = { class: "sidenav-category-items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidenavItem = _resolveComponent("SidenavItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.open(_ctx.RouterEnum.CustomerManagement.path))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_SidenavItem, {
              to: _ctx.RouterEnum.CustomerManagement.path,
              active: _ctx.isActive(_ctx.RouterEnum.CustomerManagement.path),
              text: "고객 목록",
              icon: "customers"
            }, null, 8 /* PROPS */, ["to", "active"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.open(_ctx.RouterEnum.Subscription.Chatbot.path))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createCommentVNode(" 구독상품 관리: 기본 숨김 (필요 시 v-if 조건 변경) "),
            false
              ? (_openBlock(), _createBlock(_component_SidenavItem, {
                  key: 0,
                  to: _ctx.RouterEnum.Subscription.Products.path,
                  active: _ctx.isActive(_ctx.RouterEnum.Subscription.Products.path),
                  text: "구독상품 관리",
                  icon: "products"
                }, null, 8 /* PROPS */, ["to", "active"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_SidenavItem, {
              to: _ctx.RouterEnum.Subscription.Promotions.path,
              active: _ctx.isActive(_ctx.RouterEnum.Subscription.Promotions.path),
              text: "프로모션 관리",
              icon: "promotion"
            }, null, 8 /* PROPS */, ["to", "active"]),
            _createVNode(_component_SidenavItem, {
              to: _ctx.RouterEnum.Subscription.Chatbot.path,
              active: _ctx.isActiveSubscription,
              text: "구독관리",
              icon: "subscription"
            }, null, 8 /* PROPS */, ["to", "active"]),
            (_ctx.open(_ctx.RouterEnum.Subscription.PaymentHistory.path))
              ? (_openBlock(), _createBlock(_component_SidenavItem, {
                  key: 1,
                  to: _ctx.RouterEnum.Subscription.PaymentHistory.path,
                  active: _ctx.isActive(_ctx.RouterEnum.Subscription.PaymentHistory.path),
                  text: "결제내역",
                  icon: "payment"
                }, null, 8 /* PROPS */, ["to", "active"]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.open(_ctx.RouterEnum.CallbotUsageFee.path))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_SidenavItem, {
              to: _ctx.RouterEnum.CallbotUsageFee.path,
              active: _ctx.isActiveCallbotUsageFee,
              text: "콜봇 사용료",
              icon: "payment"
            }, null, 8 /* PROPS */, ["to", "active"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.open(_ctx.RouterEnum.Integration.ChannelManagement.path))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_SidenavItem, {
              to: _ctx.RouterEnum.Integration.ChannelManagement.path,
              active: _ctx.isActive(_ctx.RouterEnum.Integration.ChannelManagement.path),
              text: "채널 관리",
              icon: "channels"
            }, null, 8 /* PROPS */, ["to", "active"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 직원 계정(리셀러 서브 계정·접근 권한, 11-02) — 「리셀러 직원 계정 관리」 권한이 있을 때만 "),
    (_ctx.open(_ctx.RouterEnum.Staff.path))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_SidenavItem, {
              to: _ctx.RouterEnum.Staff.path,
              active: _ctx.isActive(_ctx.RouterEnum.Staff.path),
              text: "직원 계정",
              icon: "security"
            }, null, 8 /* PROPS */, ["to", "active"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 지원 탭(서티라이프 지원 계정)은 비밀번호·2차 인증을 쓰지 않음(서버도 거절, SUPPORT 4) "),
    (!_ctx.blockedInSupportTab('mySecurity', _ctx.supportTab))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_SidenavItem, {
              to: _ctx.RouterEnum.Security.ChangePassword.path,
              active: _ctx.isActive(_ctx.RouterEnum.Security.ChangePassword.path),
              text: "암호 변경",
              icon: "password"
            }, null, 8 /* PROPS */, ["to", "active"]),
            _createVNode(_component_SidenavItem, {
              to: _ctx.RouterEnum.Security.MyAccount.path,
              active: _ctx.isActive(_ctx.RouterEnum.Security.MyAccount.path),
              text: "내 계정 보안",
              icon: "security"
            }, null, 8 /* PROPS */, ["to", "active"]),
            _createCommentVNode(" 옛 이메일 OTP·패스키 설정(옛 2단계 로그인 계정용). 휴대폰·이메일 수단은 「내 계정 보안」 "),
            _createVNode(_component_SidenavItem, {
              to: _ctx.RouterEnum.TwoFactorAuth.Settings.path,
              active: _ctx.isActive(_ctx.RouterEnum.TwoFactorAuth.Settings.path),
              text: "2단계 인증",
              icon: "security"
            }, null, 8 /* PROPS */, ["to", "active"])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}